import axios from 'axios';
import { ensureApiBaseUrl } from './apiConfig';

const axiosInstance = axios.create({
  baseURL: ensureApiBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${process.env.REACT_APP_TEST_TOKEN}`
  }
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      if (error.config.url.includes('/api/usuarios/validate-password')) {
        return Promise.reject(error);
      }
      window.location.href = '/loginadmin';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
